import React from 'react';

export const FiverrLogoHeader = () => (
    <svg
        preserveAspectRatio="none"
        width="100%"
        height="100%"
        overflow="visible"
        style={{ display: 'block' }}
        viewBox="0 0 89 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M81.6 13.1H78.5C76.5 13.1 75.4 14.6 75.4 17.2V26.5H69.4V13.1H66.9C64.9 13.1 63.8 14.6 63.8 17.2V26.5H57.8V8.1H63.8V10.9C64.8 8.7 66.1 8.1 68.1 8.1H75.4V10.9C76.4 8.7 77.7 8.1 79.7 8.1H81.7L81.6 13.1ZM56.4 18.7H44C44.3 20.8 45.6 21.9 47.7 21.9C49.3 21.9 50.4 21.2 50.8 20.1L56.1 21.6C54.8 24.8 51.6 26.7 47.7 26.7C41.2 26.7 38.2 21.6 38.2 17.2C38.2 12.9 40.8 7.8 47.3 7.8C54.2 7.8 56.5 13 56.5 16.9C56.5 17.8 56.5 18.3 56.4 18.7ZM50.7 15.2C50.6 13.6 49.4 12.2 47.4 12.2C45.5 12.2 44.4 13 44 15.2H50.7ZM27.8 26.5H33L39.6 8.2H33.6L30.4 18.9L27.2 8.1H21.2L27.8 26.5ZM3.4 26.5H9.3V13.1H15V26.5H20.9V8.1H9.3V7C9.3 5.8 10.2 5 11.5 5H15V0H10.6C6.3 0 3.4 2.7 3.4 6.6V8.1H0V13.1H3.4V26.5Z"
            fill="#222325"
        />
        <path
            d="M85.3 27C87.3 27 89 25.3 89 23.3C89 21.3 87.3 19.6 85.3 19.6C83.3 19.6 81.6 21.3 81.6 23.3C81.6 25.3 83.3 27 85.3 27Z"
            fill="#1DBF73"
        />
    </svg>
);

export const JobArrow = () => (
    <svg
        preserveAspectRatio="none"
        width="100%"
        height="100%"
        overflow="visible"
        style={{ display: 'block' }}
        viewBox="0 0 19.016 17.5042"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.1885 7.56358C0.53211 7.56358 0 8.09569 0 8.75208C0 9.40847 0.53211 9.94058 1.1885 9.94058V8.75208V7.56358ZM18.6679 9.59248C19.1321 9.12834 19.1321 8.37582 18.6679 7.91168L11.1043 0.348104C10.6402-0.116035 9.88769-0.116035 9.42355 0.348104C8.95941 0.812243 8.95941 1.56476 9.42355 2.0289L16.1467 8.75208L9.42355 15.4753C8.95941 15.9394 8.95941 16.6919 9.42355 17.1561C9.88769 17.6202 10.6402 17.6202 11.1043 17.1561L18.6679 9.59248ZM1.1885 8.75208V9.94058H17.8275V8.75208V7.56358H1.1885V8.75208Z"
            fill="white"
        />
    </svg>
);

export const ChevronLeft = () => (
    <svg
        preserveAspectRatio="none"
        width="100%"
        height="100%"
        overflow="visible"
        style={{ display: 'block' }}
        viewBox="0 0 8.99124 16.1842"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.09212 0.899124L0.899124 8.09212L8.09212 15.2851"
            stroke="#0C0C0D"
            strokeWidth="1.79825"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const HeroCtaArrow = () => (
    <svg
        width="17"
        height="14.7279"
        viewBox="0 0 17 14.7279"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block' }}
    >
        <path
            d="M0.75 7.364H12.75M12.75 7.364L8.25 2M12.75 7.364L8.25 12.728"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
